import { createContext, useContext, useMemo, useState } from 'react';

const Context = createContext();

export const useFourRContext = () => useContext(Context);

export function Provider({ children }) {
  const [isOpen, setOpen] = useState(false);

  const state = useMemo(() => ({ isOpen, setOpen }), [isOpen]);

  return <Context.Provider value={state}>{children}</Context.Provider>;
}
